"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const toastr_1 = __importDefault(require("toastr"));
const locale_1 = require("~/services/locale");
const ExtendedLayer_1 = require("./ExtendedLayer");
const projections_1 = require("./projections");
class ExtendedMap extends OpenLayers.Map {
    static patch(map) {
        // On applique quelques patchs à la map
        const { addLayer, setBaseLayer, getProjectionFactor } = ExtendedMap.prototype;
        const patchedMethods = { addLayer, setBaseLayer, getProjectionFactor };
        Object.assign(map, patchedMethods);
        for (const layer of map.layers || []) {
            ExtendedLayer_1.ExtendedLayer.patch(layer);
        }
        return map;
    }
    addLayer(layer) {
        layer = ExtendedLayer_1.ExtendedLayer.patch(layer);
        super.addLayer(layer);
    }
    /**
     * Patch de OpenLayers.Map.setBaseLayer
     * Permet de conserver le centre de la carte en cas de changement de projection
     * et dedéclencher l'événement changeprojection le cas échéant
     */
    setBaseLayer(newBaseLayer) {
        // S'il n'y a pas encore de baseLayer, on ne fait rien de particulier
        if (!this.baseLayer) {
            return super.setBaseLayer(newBaseLayer);
        }
        var oldProjection = this.baseLayer.projection;
        var newProjection = newBaseLayer.projection;
        var center = this.getCenter();
        var changeProjection = (oldProjection.projCode != newProjection.projCode);
        // On prépare le centre à utiliser après la reprojection
        if (changeProjection) {
            center = center.clone();
            center.transform(oldProjection, newProjection);
        }
        // On appelle l'ancienne fonction
        super.setBaseLayer(newBaseLayer);
        // On gère le changement de projection
        if (changeProjection) {
            console.log("Recenter after projection has changed");
            this.setCenter(center);
            this.events.triggerEvent('changeprojection', {
                oldProjection: oldProjection,
                newProjection: newProjection
            });
        }
        // On gère si le centre est hors cadre
        if (newBaseLayer.getMaxExtent && this.getCenter()) {
            var layerContainsCenter = newBaseLayer.getMaxExtent().containsLonLat(this.getCenter());
            if (!layerContainsCenter) {
                this.zoomToExtent(newBaseLayer.maxExtent);
                toastr_1.default.info((0, locale_1.t)('projectionHelper.recenter'));
            }
        }
    }
    /**
     * Fonction magique qui permet de rectifier les longueurs en prenant en compte la latitude
     */
    getProjectionFactor(center) {
        var centerDegree = center.clone();
        centerDegree.transform(projections_1.mapProjection, projections_1.gpsProjection);
        var projFactor = 1 / Math.cos(centerDegree.lat / 180 * Math.PI);
        return projFactor;
    }
}
exports.default = ExtendedMap;
